import React, {useState, useEffect} from 'react'

import classes from './Star.module.css'

const Star = ({children}) => {


    return (
    <div className={classes.Star}>
      <svg
        viewBox="0 0 155 137"
        xmlns="http://www.w3.org/2000/svg"
      >

        <path
          d="M99 41L155 54.5L111 70.5L78.5 136.5L45 70.5L0 54.5L56.5 41L78.5 0L99 41ZM77.5625 33.5078L66.5625 53.3896L66.4404 53.6094L66.5449 53.8389L77.5449 77.957L78 78.9551L78.4551 77.957L89.4551 53.8389L89.5596 53.6094L89.4375 53.3896L78.4375 33.5078L78 32.7168L77.5625 33.5078Z"
          fill="currentColor"
        />
      </svg>



      {children !== undefined && <div className={classes.content}>{children}</div>}
    </div>)
}



export default Star;
